import {
  ANALYTIC_EVENT,
  ANALYTIC_EVENT_TYPE_FORM_SELECT_FIELD_CHANGE,
  ANALYTIC_EVENT_TEXT_TYPE_FORM_FIELD_ONBLUR,
} from '@sravni/cosago-react-library/lib/constants';
import type { IAnalyticsEventFormField } from '@sravni/cosago-react-library/lib/types';

export const sendCustomAnalyticsEvent = (
  element: HTMLElement | null,
  type: 'onBlur' | 'onChange',
  data: IAnalyticsEventFormField,
) => {
  if (!element) {
    return;
  }

  element.dispatchEvent(
    new CustomEvent(ANALYTIC_EVENT, {
      detail: {
        data,
        type:
          type === 'onChange'
            ? ANALYTIC_EVENT_TYPE_FORM_SELECT_FIELD_CHANGE
            : ANALYTIC_EVENT_TEXT_TYPE_FORM_FIELD_ONBLUR,
      },
      bubbles: true,
      composed: true,
    }),
  );
};
